import React from 'react'
import {Icon} from '@chakra-ui/react'

const CalendarIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M33.8962 38.9463H5.97382C4.33405 38.9463 3 37.6122 3 35.9725V8.16125C3 6.52149 4.33405 5.18744 5.97382 5.18744H33.8962C35.5359 5.18744 36.87 6.52149 36.87 8.16125V35.9725C36.87 37.6122 35.5359 38.9463 33.8962 38.9463ZM5.97382 7.04028C5.35311 7.04028 4.85284 7.54055 4.85284 8.16125V35.9725C4.85284 36.5932 5.35311 37.0934 5.97382 37.0934H33.8962C34.5169 37.0934 35.0172 36.5932 35.0172 35.9725V8.16125C35.0172 7.54055 34.5169 7.04028 33.8962 7.04028H5.97382Z"
                fill="currentColor"
            />
            <path
                d="M35.7579 19.6303H4.00943C3.4999 19.6303 3.08301 19.2134 3.08301 18.7039C3.08301 18.1944 3.4999 17.7775 4.00943 17.7775H35.7579C36.2675 17.7775 36.6843 18.1944 36.6843 18.7039C36.6843 19.2134 36.2675 19.6303 35.7579 19.6303Z"
                fill="currentColor"
            />
            <path
                d="M29.2174 10.8293C28.7079 10.8293 28.291 10.4124 28.291 9.90292V1.92642C28.291 1.41689 28.7079 1 29.2174 1C29.727 1 30.1439 1.41689 30.1439 1.92642V9.90292C30.1439 10.4124 29.727 10.8293 29.2174 10.8293Z"
                fill="currentColor"
            />
            <path
                d="M10.486 10.8293C9.97646 10.8293 9.55957 10.4124 9.55957 9.90292V1.92642C9.55957 1.41689 9.97646 1 10.486 1C10.9955 1 11.4124 1.41689 11.4124 1.92642V9.90292C11.4124 10.4124 10.9955 10.8293 10.486 10.8293Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CalendarIcon
